var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 11.6666V16.6666M11.6666 14.1666H16.6666M4.99992 8.33325H6.66659C7.58706 8.33325 8.33325 7.58706 8.33325 6.66659V4.99992C8.33325 4.07944 7.58706 3.33325 6.66659 3.33325H4.99992C4.07944 3.33325 3.33325 4.07944 3.33325 4.99992V6.66659C3.33325 7.58706 4.07944 8.33325 4.99992 8.33325ZM13.3333 8.33325H14.9999C15.9204 8.33325 16.6666 7.58706 16.6666 6.66659V4.99992C16.6666 4.07944 15.9204 3.33325 14.9999 3.33325H13.3333C12.4128 3.33325 11.6666 4.07944 11.6666 4.99992V6.66659C11.6666 7.58706 12.4128 8.33325 13.3333 8.33325ZM4.99992 16.6666H6.66659C7.58706 16.6666 8.33325 15.9204 8.33325 14.9999V13.3333C8.33325 12.4128 7.58706 11.6666 6.66659 11.6666H4.99992C4.07944 11.6666 3.33325 12.4128 3.33325 13.3333V14.9999C3.33325 15.9204 4.07944 16.6666 4.99992 16.6666Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f803ba770ce91320a122ee9b465d898f.svg";
export { ForwardRef as ReactComponent };